import { CatalogConnectV2Client, CatalogImageQuery, SearchCatalogImagesFilter, SearchCatalogImagesTextFilter, SearchCatalogImagesMultiFieldTextFilter, SearchCatalogImagesFieldValue, CatalogImageQuerySort, SEARCH_CATALOG_IMAGES_FIELD, SORT_ORDER } from '@square/dashboard-items-data/clients/catalog-connect-v2';
import CatalogObjectAdapter from '@square/dashboard-items-data/adapters/connect/catalog-object';
import { CatalogObjectType } from '@square/dashboard-items-data/models/connect/catalog-object';
import UUID from 'uuid-js';
import { underscore } from '@square/dashboard-utilities/utils/keys';
import { CATALOG_SERVICE_TEMP_TOKEN_PREFIX } from '@square/dashboard-data/models/catalog/catalog-service-constants';
import { inject as service } from '@ember/service';
import CatalogError from '@square/dashboard-data/utils/catalog/catalog-error';
export const MULTIPLE_IMAGES_API_VERSION = '2021-12-15';
const QUERY_IMAGE_LIMIT = 100;
export default CatalogObjectAdapter.extend({
  features: service(),
  async uploadImage(imageFile, imageData) {
    try {
      const uploadResponse = await CatalogConnectV2Client.createCatalogImage({
        idempotencyKey: UUID.create().toString(),
        image: {
          id: `${CATALOG_SERVICE_TEMP_TOKEN_PREFIX}${UUID.create().toString()}`,
          type: CatalogObjectType.IMAGE,
          image_data: underscore(imageData || {})
        }
      }, {
        headers: {
          'Square-Version': MULTIPLE_IMAGES_API_VERSION
        }
      }, imageFile);
      this.store.pushPayload('connect/image', uploadResponse.image);
      return this.store.peekRecord('connect/image', uploadResponse.image.id);
    } catch (error) {
      if (error.status) {
        throw CatalogError.fromXhrError(error);
      } else {
        throw error;
      }
    }
  },
  _buildImageSearchQuery(query = {}) {
    const imageQuery = CatalogImageQuery.create();
    if (query.text) {
      imageQuery.set('filter', SearchCatalogImagesFilter.create({
        photoStudioOrderIdPresent: query.photoStudioOrderIdPresent,
        multiField: SearchCatalogImagesMultiFieldTextFilter.create({
          query: SearchCatalogImagesTextFilter.create({
            fuzzy: query.text
          }),
          fields: SearchCatalogImagesFieldValue.create({
            any: [SEARCH_CATALOG_IMAGES_FIELD.NAME, SEARCH_CATALOG_IMAGES_FIELD.ITEM_NAME]
          })
        })
      }));
    } else if (query.photoStudioOrderIdPresent !== null) {
      imageQuery.set('filter', SearchCatalogImagesFilter.create({
        photoStudioOrderIdPresent: query.photoStudioOrderIdPresent
      }));
    }
    const sortField = query.sortField ?? SEARCH_CATALOG_IMAGES_FIELD.NAME;
    imageQuery.set('sort', CatalogImageQuerySort.create({
      field: sortField,
      sortOrder: sortField === SEARCH_CATALOG_IMAGES_FIELD.NAME ? SORT_ORDER.ASC : SORT_ORDER.DESC
    }));
    return imageQuery;
  },
  _buildQuery(query) {
    const imageSearchQuery = this._buildImageSearchQuery(query);
    return {
      query: imageSearchQuery,
      cursor: query.cursor,
      limit: QUERY_IMAGE_LIMIT
    };
  },
  query(store, type, query) {
    const builtQuery = this._buildQuery(query);
    return CatalogConnectV2Client.searchCatalogImages(builtQuery, {
      headers: {
        'Square-Version': MULTIPLE_IMAGES_API_VERSION
      }
    }).then(response => {
      const images = response.objects ?? [];
      images.meta = {
        cursor: response.cursor
      };
      return images;
    });
  }
});